export function invoiceTableDataByBuyer() {
  return [
    {
      prop: "invoiceNumber",
      label: "发票号码",
      width: "170",
    },
    {
      prop: "invoiceClass",
      label: "发票种类",
      width: "150",
    },
    {
      prop: "bizDate",
      label: "开票日期",
      width: "100",
    },
    {
      prop: "invoiceStatus",
      label: "发票状态",
      width: "100",
    },
    {
      prop: "completed",
      label: "补全状态",
      width: "100",
    },
    {
      prop: "cargoNameList",
      label: "货物、应税劳务及服务",
      width: "200",
    },
    {
      prop: "supplierName",
      label: "销售方名称",
      width: "200",
    },
    {
      prop: "invoicePrice",
      label: "不含税金额",
      width: "100",
    },
    {
      prop: "taxRate",
      label: "税率",
      width: "100",
    },
    {
      prop: "invoiceTax",
      label: "税额",
      width: "100",
    },
    {
      prop: "invoiceTotalPrice",
      label: "价税合计",
      width: "100",
    },
    {
      prop: "remark",
      label: "备注",
      width: "200",
    },
    {
      prop: "relateContractId",
      label: "关联合同",
      width: "200",
      fixed: "right",
    },
    {
      prop: "relateExpenseId",
      label: "关联报销",
      width: "200",
      fixed: "right",
    },
  ];
}
export function invoiceTableDataBySupplier() {
  return [
    {
      prop: "invoiceNumber",
      label: "发票号码",
      width: "170",
    },
    {
      prop: "invoiceClass",
      label: "发票种类",
      width: "150",
    },
    {
      prop: "bizDate",
      label: "开票日期",
      width: "100",
    },
    {
      prop: "invoiceStatus",
      label: "发票状态",
      width: "100",
    },
    {
      prop: "completed",
      label: "补全状态",
      width: "100",
    },
    {
      prop: "cargoNameList",
      label: "货物、应税劳务及服务",
      width: "200",
    },
    {
      prop: "buyerName",
      label: "购买方名称",
      width: "200",
    },

    {
      prop: "invoicePrice",
      label: "不含税金额",
      width: "100",
    },
    {
      prop: "taxRate",
      label: "税率",
      width: "100",
    },
    {
      prop: "invoiceTax",
      label: "税额",
      width: "100",
    },
    {
      prop: "invoiceTotalPrice",
      label: "价税合计",
      width: "100",
    },
    {
      prop: "remark",
      label: "备注",
      width: "200",
    },
    {
      prop: "relateContractId",
      label: "关联合同",
      width: "200",
      fixed: "right",
    },
  ];
}

export function invoiceTableTransData(data) {
  // 补全状态 completed 0:未补全,1:已补全
  // 发票种类 invoiceClass
  // 发票状态 invoiceStatus  0:正常，1:失控，2:作废，3:红冲，4:异常
  // 发票状态映射
  const INVOICE_STATUS_MAP = {
    0: "正常",
    1: "失控",
    2: "作废",
    3: "红冲",
  };
  const INVOICE_TYPE_MAP = {
    0: "增值税专用发票",
    1: "增值税普通发票",
    2: "无票销售收入（未开具发票）",
    3: "普通发票",
    4: "货运发票",
    5: "机动车销售发票",
    6: "纳税检查调整",
    7: "通用机打发票",
    8: "增值税电子普通发票",
    9: "增值税普通发票（卷票）",
    10: "增值税电子专用发票",
    11: "区块链电子发票",
    31: "电子发票（增值税专用发票）",
    32: "电子发票（普通发票）",
  };
  // 补全状态映射
  const COMPLETED_STATUS_MAP = {
    0: "未补全",
    1: "已补全",
  };
  data.forEach((item) => {
    item.taxRate = item.taxRate * 100 + "%";
    item.completed = COMPLETED_STATUS_MAP[item.completed];
    item.invoiceStatus = INVOICE_STATUS_MAP[item.invoiceStatus];
    item.invoiceClass = INVOICE_TYPE_MAP[item.invoiceClass];
    if (item.invoiceCargoList.length > 0) {
      item.cargoNameList = item.invoiceCargoList
        .map((item) => item.cargoName)
        .join("、");
    }
  });
  return data;
}

export function invoiceType() {
  return [
    {
      label: "增值税专用发票",
      value: "0",
    },
    {
      label: "增值税普通发票",
      value: "1",
    },
    {
      label: "无票销售收入（未开具发票）",
      value: "2",
    },
    {
      label: "普通发票",
      value: "3",
    },
    {
      label: "货运发票",
      value: "4",
    },
    {
      label: "机动车销售发票",
      value: "5",
    },
    {
      label: "纳税检查调整",
      value: "6",
    },
    {
      label: "通用机打发票",
      value: "7",
    },
    {
      label: "增值税电子普通发票",
      value: "8",
    },
    {
      label: "增值税普通发票（卷票）",
      value: "9",
    },
    {
      label: "增值税电子专用发票",
      value: "10",
    },
    {
      label: "区块链电子发票",
      value: "11",
    },
    {
      label: "电子发票（增值税专用发票）",
      value: "31",
    },
    {
      label: "电子发票（普通发票）",
      value: "32",
    },
  ];
}
